const rootElement = document.querySelector('[data-selector="hb-lp-how-it-works-container"]')

const swiperEl = rootElement.querySelector('[data-selector="swiper"]')
const counterEl = rootElement.querySelector('[data-selector="slider-counter"]')

const swiper = new Swiper(swiperEl, { 
  spaceBetween: 10, 
  slidesPerView: 1, 
  loop: false,
  navigation: {
    nextEl: rootElement.querySelector('[data-selector="next-button"]'),
    prevEl: rootElement.querySelector('[data-selector="prev-button"]')
  },
  on: {
    slideChange: updateCounter
  }
})

function updateCounter() {
  const current = swiper.realIndex + 1
  const total = swiper.slides.length

  counterEl.textContent = `${current}/${total}`
}

updateCounter()
